<template>
    <a-drawer
      :title="'项目信息-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="40%"
    >
        <div class="input-box">
            <p>项目来源：</p>
            <a-input class="input" v-model="info.sourceName" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目下达部门：</p>
            <a-input class="input" v-model="info.department" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目级别：</p>
            <a-select class="input" allowClear v-model="info.projectLevel" :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in xmjbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目编码：</p>
            <a-input class="input" v-model="info.projectNo" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>项目名称：</p>
            <a-input class="input" v-model="info.projectName" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>负责人：</p>
            <a-select 
                class="input" 
                allowClear
                show-search
                :filter-option="filterOption"
                v-model="info.headerName"
                option-label-prop="label"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>项目初始年月：</p>
            <a-month-picker class="input" :disabled="actionName=='查看'" format="YYYY-MM" v-model="info.startDate" @change="(date, dateString)=>{info.startDate=dateString}" />
        </div>
        <div class="input-box">
            <p>项目结束年月：</p>
            <a-month-picker class="input" :disabled="actionName=='查看'" format="YYYY-MM" v-model="info.endDate" @change="(date, dateString)=>{info.endDate=dateString}" />
        </div>
        <div class="input-box">
            <p>项目合同总经费（万元）：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.totalFunds" />
        </div>
        <div class="input-box">
            <p>单位本学科的到账经费（万元）：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.unitFunds" />
        </div>
        <div class="input-box">
            <p>备注：</p>
            <a-textarea class="input" :rows="4" :disabled="actionName=='查看'" v-model="info.remark" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/research/project'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    sourceName:null,
                    department:null,
                    projectLevel:null,
                    projectNo:null,
                    projectName:null,
                    headerName:null,
                    startDate:null,
                    endDate:null,
                    totalFunds:null,
                    unitFunds:null,
                    remark:null,
                },
                xmjbArr:[],
                jsArr:[],
                yearShowOne:false,
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getTeacher().then(res=>{
                    this.jsArr=res.data;
                })
                getDicts({dataCode:'KYCG-XMJB',status:true}).then(res=>{
                    this.xmjbArr=res.data.dicts;
                    this.info.projectLevel=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.courseDirectorNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    decideDate:null,
                    consProjectTypeCode:null,
                    projectLevelCode:null,
                    courseNo:null,
                    courseName:null,
                    courseAttrCode:null,
                    courseDirectorNo:null,
                    courseDirectorName:null,
                    remark:null
                };
                this.visible = false;
                this.$parent.fetch()
            },
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                console.log(this.info)
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改项目成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            openChangeOne(status) {
                if (status){
                    this.yearShowOne =  true
                }
            },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            }

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 15rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 15rem);
    }
    .input-box .tips{
        width: calc(100% - 15rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
